// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD_7SuEYmQqiyqRpGmLMKzA8brLJL-UIEM",
  authDomain: "netflixgpt-295a4.firebaseapp.com",
  projectId: "netflixgpt-295a4",
  storageBucket: "netflixgpt-295a4.appspot.com",
  messagingSenderId: "976808874001",
  appId: "1:976808874001:web:9123ffb15599f4d211a1b0",
  measurementId: "G-GMT63ZSBKH",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth();
